/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

window.addEventListener("load", function(){
  if($(".product-single__box").length){

    var isFabricAvailable = false;
    $(".product-single__variant .selector-wrapper").each(function(){
      $(this).find("select option").each(function(){
        if($(this).attr("value") == "Fabric"){
          isFabricAvailable = true;
        }
      });
    });

    if(isFabricAvailable){
      $(".product-single__qty .product-single__qty-input").append("<input type='hidden' name='quantity' class='custom_qty'>");

      $(".product-single__qty .product-single__qty-input input.js-qty__num").on("keyup focusin focusout change", function(){
        updateQtyPrice();
      });

      $(".product-single__qty .product-single__qty-input .js-qty__adjust").on("click", function(){
        updateQtyPrice();
      });

      $(".product-single__variant select").on("change", function(){
        updateQtyPrice();
        $(".product-single__qty .product-single__qty-input input.js-qty__num").val(1);
      });
      
      setTimeout(function(){
        updateQtyPrice();
      },500);

      setTimeout(function(){
        updateQtyPrice();
      },1000);


      function updateQtyPrice(){
        var isFabricSelected = false;
        $(".product-single__variant .selector-wrapper").each(function(){
          if($(this).find("select").val() == "Fabric"){
            isFabricSelected = true;
          }
        });

        var oldQty, newQty, newPrice, newComPrice;
        var cvPrice = parseInt($(".product-single__variant select[name='id'] option:selected").attr("data-price"));
        var cvComPrice = parseInt($(".product-single__variant select[name='id'] option:selected").attr("data-cprice"));
        $(".meter_info").remove();
        $(".meter_info2").remove();
        if(isFabricSelected){
          oldQty = $(".product-single__qty input.js-qty__num").val();
          newQty = parseInt(oldQty * 10);
          console.log(newQty);
          if(newQty >= 10){
            $('.product-single__add button').removeAttr('disabled');
          }else{
            $('.product-single__add button').attr('disabled','disabled');
          }
          
          newPrice = parseFloat(cvPrice * newQty);
          if(cvComPrice != ''){
          	newComPrice = parseFloat(cvComPrice * newQty);
          } 
          
          $(".product-single__qty .product-single__qty-input input.js-qty__num").attr("data-diff", "0.1");
          $(".product-single__qty").append("<span class='meter_info'>"+oldQty+" <span>Metres</span></span><span class='meter_info2'>Please note that our minimum cut is 1m</span>");
        }else{
          newQty = $(".product-single__qty input.js-qty__num").val();
          newPrice = cvPrice;
          
          $(".product-single__qty .product-single__qty-input input.js-qty__num").attr("data-diff", "1");
        }
        var currentIso = $("[data-current-iso]").data('current-iso');

        $(".product-single__qty .custom_qty").val(newQty);
        newPrice = Shopify.formatMoney(newPrice, '$ {{amount}} ' + currentIso);
        $(".product-single__price-number .money").html(newPrice);
        
        if(cvComPrice != ''){ 
          newComPrice = Shopify.formatMoney(newComPrice, '$ {{amount}} ' + currentIso);
          $(".product-single__price-compare .money").html(newComPrice);
        }
        
        
        Currency.convertAll('NZD', Currency.currentCurrency);
       // console.log(newPrice);

      }
    }
  }
  
  
  $(".js-cart-trigger").click(function(){
    if($(".ajaxcart__products .ajaxcart__product").length){
      $(".ajaxcart__products .meter_info").remove();
      $(".ajaxcart__products .ajaxcart__product").each(function(){
        if($(this).hasClass("cart_fabric_item")){
          var vMeter = parseFloat($(this).find(".ajaxcart__qty input").val());
          var vCM = parseInt(vMeter * 10);
          $(this).find(".ajaxcart__qty").after("<span class='meter_info'>"+vMeter+" <span>Metres</span></span>");
        }
      });
    }
  });
  
   $('.product-single__box input[type="text"]').keyup(function(e){
    var val = $(this).val();
    if(val < 1 ){
      $('.meter_info_error').remove()
      $('.product-single__qty-input').after('<span class="meter_info_error">Please Enter minimum amount of cut is 1m</span>')
      $('.product-single__add').css({'opacity':'0.6','pointer-events': 'none'})
      setTimeout(function(){
        $('.meter_info_error').remove()
      },2500)
    }else{
        $('.meter_info_error').remove()
      $('.product-single__add').removeAttr('style')
    }
  });
  
   $('.product-single__qty-input .js-qty__adjust').on('click',function(e){
    var val = $('.product-single__box input[type="text"]').val();
    if(val < 1 ){
      $('.meter_info_error').remove()
      $('.product-single__qty-input').after('<span class="meter_info_error">Please Enter minimum amount of cut is 1m</span>')
      $('.product-single__add').css({'opacity':'0.6','pointer-events': 'none'})
      setTimeout(function(){
        $('.meter_info_error').remove()
      },2500)
    }else{
        $('.meter_info_error').remove()
      $('.product-single__add').removeAttr('style')
    }
  });

  setInterval(function() {
      $('.upcart-cart-body .upcart-product-item').each(function () {
          var this_qty = $(this).find('.upcart-product-quantity-input').val();
          $(this).find('.upcart-product-quantity-input').closest('div').addClass('disable-input');
          var option = $(this).find('.upcart-item-option-value').html();
          if(option != undefined){
              if(option.indexOf('Fabric') != -1){
                  if(this_qty <= 10){
                      $(this).find('.upcart-product-quantity-input').closest('div').addClass('disabled');
                      $(this).find('.upcart-product-quantity-input').attr({'min': 10, 'type': 'number'});
                  }else{
                      $(this).find('.upcart-product-quantity-input').closest('div').removeClass('disabled');
                      $(this).find('.upcart-product-quantity-input').attr({'min': 10, 'type': 'number'});
                  }
              }
          }
      })
  }, 1000)
  
});



